import { Outlet, createFileRoute } from '@tanstack/react-router'

import { StorageRail } from '@/features/storage/StorageRail'

export const Route = createFileRoute('/locations')({ component: StorageLayout })

/** Storage: the rail of places beside whatever place is open. */
function StorageLayout() {
  return (
    <div className="grid min-h-full grid-cols-1 lg:grid-cols-[200px_minmax(0,1fr)]">
      <StorageRail />
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  )
}
